var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import { TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import TextArea from '@shared/input/TextArea';
import TextInput from '@shared/input/TextInput';
import { CheckBox } from '@shared/input/CheckBox';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import SelectInput from '@shared/input/SelectInput';
import { KpiColumnType, KpiColumnOperation, ConditionalFormatting, conditionalFormattingOptions, conditionalFormattingTypeOptions, kpiColumnTypeMeta, } from '@util/enums';
import { SimpleGrid } from '@styled/Grid';
import { ModalBody } from '@styled/Modal';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
function ColumnEditModal(_a) {
    var _b, _c, _d, _e;
    var item = _a.item, tagById = _a.tagById, onSave = _a.onSave, columns = _a.columns;
    var L = useLanguage().L;
    var _f = __read(useState(item
        ? __assign({}, item) : {
        title: '',
        subheader: '',
        tagIdsOr: [],
        tags: [],
        type: KpiColumnType.SELECTOR,
        hide: false,
    }), 2), column = _f[0], setState = _f[1];
    var _g = __read(useState({}), 2), invalid = _g[0], setInvalid = _g[1];
    var save = function () {
        var columnCopy = __assign({}, column);
        var invalid = isValid(columnCopy);
        if (Object.keys(invalid).length > 0) {
            setInvalid(invalid);
        }
        else {
            setInvalid({});
            onSave(columnCopy);
            Manager.closeModal();
        }
    };
    var isValid = function (data) {
        var invalid = {};
        if (!data.title) {
            invalid.title = L('Header cannot be empty');
        }
        if (data.type === undefined) {
            invalid.type = L('You must choose a format');
        }
        if (data.type === 'DIFF') {
            if (data.opA === undefined || data.opB === undefined || data.operation === undefined) {
                invalid.diff = L('Calculation fields cannot be empty');
                if (data.opA === undefined) {
                    invalid.opA = true;
                }
                if (data.opB === undefined) {
                    invalid.opB = true;
                }
                if (data.operation === undefined) {
                    invalid.operation = true;
                }
            }
        }
        return invalid;
    };
    var selectTag = function (tagId) {
        var data = __assign({}, column);
        if (!data.tags) {
            data.tags = [tagId];
        }
        else {
            data.tags.push(tagId);
        }
        setState(data);
    };
    var removeTag = function (tagId) {
        var _a;
        var data = __assign({}, column);
        data.tags = (_a = data.tags) === null || _a === void 0 ? void 0 : _a.filter(function (tId) { return tId !== tagId; });
        setState(data);
    };
    var selectedTags = (_c = (_b = column.tags) === null || _b === void 0 ? void 0 : _b.map(function (tId) { return tagById[tId]; }).filter(function (t) { return t !== undefined; })) !== null && _c !== void 0 ? _c : [];
    var title = item ? "".concat(L('Editing column'), " \"").concat(item.title, "\"") : L('Add new column');
    return (React.createElement(Modal, { width: 500 },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(TextArea, { rows: 2, label: L('Header'), name: "title", value: column.title, onChange: function (e) { return setState(__assign(__assign({}, column), { title: e.target.value })); }, invalidString: invalid.title, bottomMargin: true }),
                React.createElement(TextInput, { label: L('Subheader'), name: "title", value: column.subheader || '', onChange: function (e) { return setState(__assign(__assign({}, column), { subheader: e.target.value })); }, bottomMargin: true }),
                React.createElement(SelectInput, { name: "type", value: column.type, label: L('Type'), onChange: function (e) { return setState(__assign(__assign({}, column), { type: e.target.value })); }, options: kpiColumnTypeMeta.map(function (o) { return ({ label: L(o.label), value: o.value }); }), bottomMargin: true }),
                column.type === KpiColumnType.DIFF && (React.createElement(CalculatedType, { columns: columns, id: column.id, opA: column.opA, opB: column.opB, operation: column.operation, onChange: function (e) { return setState(__assign(__assign({}, column), e)); }, invalid: invalid })),
                React.createElement(SelectInput, { name: "conditionalFormatting", value: (_d = column.conditionalFormatting) !== null && _d !== void 0 ? _d : null, label: L('Conditional formatting'), onChange: function (e) {
                        return setState(__assign(__assign({}, column), { conditionalFormatting: e.target.value }));
                    }, options: conditionalFormattingOptions.map(function (cfo) { return ({ label: L(cfo.label), value: cfo.value }); }), bottomMargin: true }),
                column.conditionalFormatting !== undefined &&
                    column.conditionalFormatting !== ConditionalFormatting.OFF &&
                    column.conditionalFormatting !== ConditionalFormatting.ARROWS ? (React.createElement(SelectInput, { name: "conditionalFormattingType", value: (_e = column.conditionalFormattingType) !== null && _e !== void 0 ? _e : null, label: L('Type'), onChange: function (e) {
                        return setState(__assign(__assign({}, column), { conditionalFormattingType: e.target.value }));
                    }, options: conditionalFormattingTypeOptions.map(function (cfto) { return ({
                        label: L(cfto.label),
                        value: cfto.value,
                    }); }), bottomMargin: true })) : null,
                column.conditionalFormatting !== undefined &&
                    column.conditionalFormatting !== ConditionalFormatting.OFF ? (React.createElement(CheckBox, { checked: column.hideNumbers, label: L('Hide numbers'), action: function () { return setState(__assign(__assign({}, column), { hideNumbers: !column.hideNumbers })); }, css: { marginBottom: '10px' } })) : null,
                column.type === KpiColumnType.SELECTOR && (React.createElement(FormField, null,
                    React.createElement(FormFieldLabel, null, L('Variable and Dimensions')),
                    React.createElement(Tags, { tags: selectedTags, select: selectTag, remove: removeTag, filterByTypes: [TagType.Account, TagType.Dimension] }))))),
        React.createElement(ModalFooter, { done: save })));
}
var CalculatedType = function (_a) {
    var columns = _a.columns, opA = _a.opA, opB = _a.opB, operation = _a.operation, id = _a.id, onChange = _a.onChange, invalid = _a.invalid;
    var L = useLanguage().L;
    var _b = __read(useState({ opA: opA, opB: opB, operation: operation }), 2), state = _b[0], setState = _b[1];
    useEffect(function () {
        if (state.opA !== undefined || state.opB !== undefined || state.operation !== undefined) {
            onChange(state);
        }
    }, [state]);
    var columnOptions = columns
        .filter(function (c) { return c.id !== id; })
        .map(function (c, idx) { return ({ label: "".concat(idx + 1), value: c.id }); });
    return (React.createElement(FormField, { "$bottomSpace": true },
        React.createElement(SimpleGrid, { "$columnNumber": 3 },
            React.createElement(SelectInput, { name: "opA", options: columnOptions, value: state.opA, onChange: function (e) { return setState(__assign(__assign({}, state), { opA: e.target.value })); }, label: L('Column 1'), invalid: invalid === null || invalid === void 0 ? void 0 : invalid.opA }),
            React.createElement(SelectInput, { name: "operation", options: Object.values(KpiColumnOperation).map(function (value) { return ({
                    value: value,
                    label: value,
                }); }), value: state.operation, onChange: function (e) { return setState(__assign(__assign({}, state), { operation: e.target.value })); }, label: L('Operation'), invalid: invalid === null || invalid === void 0 ? void 0 : invalid.operation }),
            React.createElement(SelectInput, { name: "opB", options: columnOptions, value: state.opB, onChange: function (e) { return setState(__assign(__assign({}, state), { opB: e.target.value })); }, label: L('Column 2'), invalid: invalid === null || invalid === void 0 ? void 0 : invalid.opB })),
        (invalid === null || invalid === void 0 ? void 0 : invalid.diff) && React.createElement(FormFieldErrorHelp, null, invalid === null || invalid === void 0 ? void 0 : invalid.diff)));
};
export default ColumnEditModal;
